// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/place_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import { file_proto_model_system_errors } from "../model/system/errors_pb";
import { file_proto_model_entity_place } from "../model/entity/place_pb";
import { file_proto_model_search_place_search } from "../model/search/place_search_pb";
import { file_proto_model_search_search_session } from "../model/search/search_session_pb";

/**
 * Describes the file proto/service/place_service.proto.
 */
export const file_proto_service_place_service = /*@__PURE__*/
  fileDesc("CiFwcm90by9zZXJ2aWNlL3BsYWNlX3NlcnZpY2UucHJvdG8SBmNhcm1lbiJmChNTZWFyY2hQbGFjZXNSZXF1ZXN0EiMKBnNlYXJjaBgBIAEoCzITLmNhcm1lbi5QbGFjZVNlYXJjaBIVCg1sYW5ndWFnZV9jb2RlGAIgASgJEhMKC3JlZ2lvbl9jb2RlGAMgASgJImQKFFNlYXJjaFBsYWNlc1Jlc3BvbnNlEi0KDnNlYXJjaF9zZXNzaW9uGAEgASgLMhUuY2FybWVuLlNlYXJjaFNlc3Npb24SHQoGZXJyb3JzGAIgAygLMg0uY2FybWVuLkVycm9yIp0BChZHZXRQbGFjZURldGFpbHNSZXF1ZXN0EhAKCHBsYWNlX2lkGAEgASgJEi4KCmZpZWxkX21hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrEhUKDWxhbmd1YWdlX2NvZGUYAyABKAkSEwoLcmVnaW9uX2NvZGUYBCABKAkSFQoNc2Vzc2lvbl90b2tlbhgFIAEoCSJ/ChdHZXRQbGFjZURldGFpbHNSZXNwb25zZRIcCgVwbGFjZRgBIAEoCzINLmNhcm1lbi5QbGFjZRIdCgZlcnJvcnMYAiADKAsyDS5jYXJtZW4uRXJyb3ISJwoIcHJvdmlkZXIYAyABKA4yFS5jYXJtZW4uUGxhY2VQcm92aWRlcjKtAQoMUGxhY2VTZXJ2aWNlEkkKDFNlYXJjaFBsYWNlcxIbLmNhcm1lbi5TZWFyY2hQbGFjZXNSZXF1ZXN0GhwuY2FybWVuLlNlYXJjaFBsYWNlc1Jlc3BvbnNlElIKD0dldFBsYWNlRGV0YWlscxIeLmNhcm1lbi5HZXRQbGFjZURldGFpbHNSZXF1ZXN0Gh8uY2FybWVuLkdldFBsYWNlRGV0YWlsc1Jlc3BvbnNlQipaKGdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL3NlcnZpY2ViBnByb3RvMw", [file_google_protobuf_field_mask, file_proto_model_system_errors, file_proto_model_entity_place, file_proto_model_search_place_search, file_proto_model_search_search_session]);

/**
 * Describes the message carmen.SearchPlacesRequest.
 * Use `create(SearchPlacesRequestSchema)` to create a new message.
 */
export const SearchPlacesRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_place_service, 0);

/**
 * Describes the message carmen.SearchPlacesResponse.
 * Use `create(SearchPlacesResponseSchema)` to create a new message.
 */
export const SearchPlacesResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_place_service, 1);

/**
 * Describes the message carmen.GetPlaceDetailsRequest.
 * Use `create(GetPlaceDetailsRequestSchema)` to create a new message.
 */
export const GetPlaceDetailsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_place_service, 2);

/**
 * Describes the message carmen.GetPlaceDetailsResponse.
 * Use `create(GetPlaceDetailsResponseSchema)` to create a new message.
 */
export const GetPlaceDetailsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_place_service, 3);

/**
 * Service for searching places and retrieving place details.
 * Provides pass-through access to multiple place providers without caching.
 *
 * @generated from service carmen.PlaceService
 */
export const PlaceService = /*@__PURE__*/
  serviceDesc(file_proto_service_place_service, 0);

